<template>
  <!-- ปุ่มรายชื่อห้องตรวจ -->
  <div class="container-fluid p-1 text-start border border-1 mt-1 mb-1 bg-light">
    <div class="row">
      <div class="col-sm-2">
        <h5>
          <span class="badge rounded-pill text-white p-2 px-3" style="background:LimeGreen">
          <b>Testsuits : ชุดเทสตรวจ</b>
          </span>
        </h5>
      </div>
      <div class="col-sm">
        <!-- รายชื่อห้องตรวจ แสดงให้คลิกเพื่อกรองข้อมูล -->
        <input type="radio" class="btn-check me-2" name="optionsAll" id="optionsAll" value="0" v-model="rdRoomTypeID" @change="roomType_Changed()">
        <label class="btn btn-outline-success me-3" for="optionsAll">ทุกห้อง</label>
        <template v-for="item in roomtypeList" :key="item.id">
          <input type="radio" class="btn-check" :name="'options' + item.id" :id="'options' + item.id" :value="item.id" v-model="rdRoomTypeID" @change="roomType_Changed()">
          <label class="btn btn-outline-success me-1" :for="'options' + item.id">{{item.room_name}}</label>
        </template>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <!-- แสดงผลแบบ ตาราง และ ปุ่ม -->
        <div class="form-check form-switch mt-2">
          <input class="form-check-input" type="checkbox" id="flexSwitchCheckChecked" v-model="chkTableView" checked>
          <label class="form-check-label" for="flexSwitchCheckChecked">แสดงในรูปแบบตารางชุดตรวจ</label>
        </div>
      </div>
    </div>
  </div>
  <MTestsuits1View v-if="chkTableView" :key="countRefresh"
    :roomtypeRows="roomtypeList"
    :datalistsForExcel="datalistsForExcel"
    :rdRoomTypeID="rdRoomTypeID"
    @onDataChangedEvent="refreshView"></MTestsuits1View>

  <MTestsuits1BtnView v-if="!chkTableView" :key="countRefresh"
    :roomtypeRows="roomtypeList"
    :datalistsForExcel="datalistsForExcel"
    :rdRoomTypeID="rdRoomTypeID"
    @onDataChangedEvent="refreshView"></MTestsuits1BtnView>
</template>

<script>
import { MyApiClient } from '../myjs/my-api-client.js'
// Bootstrap and jQuery libraries
import 'bootstrap/dist/css/bootstrap.min.css'
import 'jquery/dist/jquery.min.js'
// Datatable Modules
import 'datatables.net-dt/js/dataTables.dataTables'
import 'datatables.net-dt/css/jquery.dataTables.min.css'
// import $ from 'jquery'
// import Swal from 'sweetalert2'
import { inject, ref } from 'vue'

import MTestsuits1View from './MTestsuits1View.vue'
import MTestsuits1BtnView from './MTestsuits1BtnView.vue'

export default {
  setup () {
    var globalCorpID = inject('corpID', ref(-1))
    var globalCorpName = inject('corpName', ref(''))
    var globalBranchID = inject('branchID', ref(-1))
    var globalUserID = inject('userID', ref(-1))
    var globalUserName = inject('userName', ref(''))
    var globalUserOfficialName = inject('userOfficialName', ref(''))
    var globalUserPosition = inject('userPosition', ref(''))
    return {
      globalCorpID, globalCorpName, globalBranchID, globalUserID, globalUserName, globalUserOfficialName, globalUserPosition
    }
  },
  name: 'Testsuit',
  components: {
    MTestsuits1View, MTestsuits1BtnView
  },
  data () {
    return {
      chkTableView: true,
      countRefresh: 0,

      rdRoomTypeID: 0,
      roomtypeList: [],
      datalistsForExcel: []
    }
  },
  mounted () {
    this.getRoomTypeData()
    // รายการชุดตรวจ+เทส สำหรับ export เป็น excel file
    this.getTestsuitAndItemsData()
  },
  methods: {
    refreshView () {
      this.countRefresh++
    },
    roomType_Changed () {
      // กรณีเปลี่ยนห้องตรวจจะ filter ชุดตรวจ
      this.refreshView()
    },
    getRoomTypeData () {
    // axios.get('http://www.irissar.com/projects/parking/service/park_building/pb_like.php?key=%' + this.search_text + '%', {crossDomain: true})
      MyApiClient.get('getdata/roomtype_all.php?C1=' + this.globalCorpID)
        .then((resp) => {
        //   console.log(resp.data.response)
          this.roomtypeList = resp.data.response
          // setTimeout(function () { $('#myTSTable').DataTable() }, 0)
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    // รายการชุดตรวจ+เทส สำหรับ export เป็น excel file
    getTestsuitAndItemsData () {
      MyApiClient.get('getdata/testsuitsAndItems_all.php?C1=' + this.globalCorpID)
        .then((resp) => {
          this.datalistsForExcel = resp.data.response
        })
        .catch((err) => {
          console.log(err.response)
        })
    }
  }
}

</script>

<style>
.page-scroll {
  max-height: 600px;
  height: 600px;
  overflow: auto;
  /* height: 450px;
  overflow-y: scroll; */
}
.table-box:hover{
    background-color: rgba(255, 234, 5, 0.989);
    color: black;
    cursor: pointer;
    /* border: 5px solid white; */
}
</style>
